{
  "slug": "rowan-atkinson-iq",
  "title": "Rowan Atkinson IQ: what is actually verified?",
  "description": "Review popular Rowan Atkinson IQ claims, the documented evidence about his education and career, and why no exact score should be stated without a primary report.",
  "summary": "Rowan Atkinson’s education and comedy career are documented. A precise IQ value repeated online is not equivalent to an authenticated score from a named standardized test.",
  "category": "Famous people and IQ claims",
  "sections": [
    {
      "heading": "What is documented",
      "paragraphs": [
        "The Queen’s College, Oxford lists Rowan Atkinson with engineering degrees from Newcastle and Oxford. His acting and writing career demonstrates accomplishment in a different domain.",
        "Education and creative success can be described from reliable records, but neither produces a unique IQ number."
      ]
    },
    {
      "heading": "What an IQ claim would need",
      "paragraphs": [
        "A verifiable claim would identify the instrument, edition, date, administration, norm group, score type, and a trustworthy primary record. Viral articles frequently repeat a number without that chain of evidence.",
        "Admissions, academic credentials, and anecdotes cannot be reliably converted into IQ points because they have different content, purposes, and comparison groups."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "No authenticated standardized score is established by the sources used for this article. Precise numbers should therefore be treated as unverified.",
        "That conclusion does not minimize Atkinson’s achievements. It distinguishes documented biography from unsupported psychometric claims."
      ]
    }
  ],
  "faqs": [
    {
      "question": "What is Rowan Atkinson’s IQ?",
      "answer": "No authenticated standardized IQ report is publicly established in the sources used here."
    },
    {
      "question": "Does an engineering degree prove a particular IQ?",
      "answer": "No. Educational achievement cannot be converted into one exact standardized intelligence score."
    }
  ],
  "related": ["albert-einstein-iq", "highest-iq-ever-recorded", "how-is-iq-measured"],
  "sources": [
    {
      "label": "The Queen’s College, Oxford — Rowan Atkinson",
      "url": "https://www.queens.ox.ac.uk/people/mr-rowan-atkinsonbsc-newc-msc-oxf/"
    }
  ]
}
